export default "__VITE_ASSET__BVZKQo5T__"